/** Consolidated download name: Foxquilt_Quote_<business>_<eoNumber>_<glNumber>_<stamp>.pdf.
 * The stamp is local time as YYYYMMDDHHMMSS — sortable and safe on all filesystems. */
const pad = (value: number): string => String(value).padStart(2, '0');

export const formatDateTimeStamp = (date: Date): string =>
  `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}` +
  `${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;

/** The business name is free text; replace the characters filesystems refuse.
 * Spaces and ordinary punctuation stay, so existing names do not change. */
export const sanitizeFileNamePart = (value: string): string =>
  // eslint-disable-next-line no-control-regex
  value.replace(/[\\/:*?"<>|\u0000-\u001f]+/g, '_').trim();

/** File-name label for a product. Only E&O has an internal code ('EO') that
 * customers do not know; GL keeps its long-standing label unchanged. */
export const lobTypeToFileLabel = (lobType: string): string =>
  lobType === 'EO' ? 'E&O' : lobType;

const getConsolidatedQuoteFileName = (
  businessName: string,
  eoQuoteNumber: string,
  glQuoteNumber: string,
  now: Date = new Date()
): string => {
  return `Foxquilt_Quote_${sanitizeFileNamePart(
    businessName
  )}_${eoQuoteNumber}_${glQuoteNumber}_${formatDateTimeStamp(now)}.pdf`;
};

export default getConsolidatedQuoteFileName;
